function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var AudioBoxTemplate = require('./audio-box.template');

/**
 *
 *  Audio Box is a hook for a voice call, it adds an <audio> element to the DOM
 *  and can display the identicons of the people involved in the call
 *
 */
var AudioBox = /*#__PURE__*/function () {
  function AudioBox(app, mod, stream_id, container) {
    var _this = this;
    _classCallCheck(this, AudioBox);
    this.app = app;
    this.mod = mod;
    this.stream_id = stream_id;
    this.container = container;
    this.stream = null;
    app.connection.on('peer-toggle-audio-status', function (_ref) {
      var enabled = _ref.enabled,
        public_key = _ref.public_key;
      if (public_key !== _this.stream_id) return;
      console.debug('TALK.audioBox [peer-toggle-audio-status]', enabled);
      var audio_box = document.getElementById("audiostream_".concat(_this.stream_id));
      if (audio_box) {
        var element = audio_box.querySelector(".fa-microphone-slash");
        if (!enabled) {
          if (!element) {
            audio_box.insertAdjacentHTML('beforeend', "<i class=\"fa fa-microphone-slash\"></i>");
          }
          audio_box.classList.add('muted');
        } else {
          if (element) {
            element.remove();
          }
          audio_box.classList.remove('muted');
        }
      }
    });
  }
  return _createClass(AudioBox, [{
    key: "render",
    value: function render(stream) {
      this.stream = stream;
      if (!document.getElementById("audiostream_".concat(this.stream_id))) {
        this.app.browser.addElementToSelector(AudioBoxTemplate(this.app, this.mod, this.stream_id), this.container);
      }
      var audioBox = document.getElementById("audiostream_".concat(this.stream_id));
      audioBox.firstElementChild.srcObject = this.stream;
    }
  }, {
    key: "remove",
    value: function remove() {
      var audio_box = document.getElementById("audiostream_".concat(this.stream_id));
      if (audio_box) {
        audio_box.remove();
      }
    }
  }]);
}();
module.exports = AudioBox;